// Анкета «Кодовое слово в комментарии» (Instagram). До 01.09.2026 звалась «Бот на
// кодовое слово» и умела два входа — директ и комментарий; владелец оставил ОДИН:
// человек пишет кодовое слово под публикацией, бот отвечает ему в личных сообщениях.
// Личка как ВХОД ушла к соседней анкете «Подарок за подписку» (gift-ig.ts).
//
// Тело мастера (шаги, поля, сборка схемы) — общее у обеих инста-анкет и живёт
// в ig-wizard.ts: здесь только настройка запуска, имя, описание и сцена первого экрана.
// Сборка — патчи канона шаблона hotcat:1-keyword-bot (миграция 20260805000000).
import { makeIgWizard, type IgWizardCfg } from './ig-wizard';
import type { TemplateWizardDef, WizardLocale } from './core';

/** Настройка анкеты — ею же ответы читает страница бота клиента (Scriptera A, lib/adm/bot-view.ts readIgAnswers). */
export const KEYWORD_BOT_IG_CFG: IgWizardCfg = {
  id: 'keyword-bot-ig',
  templateSource: 'hotcat:1-keyword-bot',
  // Вход один и жёсткий: комментарий под публикацией (владелец 31.08, подтверждено 02.09:
  // «Кодовое слово в комментарии — вход только комментарий»). Личка у этого бота —
  // только продолжение разговора нажатием кнопки. План: docs/TRIGGER-WIZARD-PLAN.md.
  fixedEvents: ['comment'],
  // Чат на первом экране — сцена «Слово в комментарии» с примеров работ (ТЗ-3 Т1).
  // ВРЕМЕННО ДЛЯ СЪЁМКИ РОЛИКА (владелец 22.09.2026): после съёмки вернуть 's2'.
  demoScene: 's2',

  // ЗНАКОМСТВО — первый экран анкеты (ТЗ-2 З1): человек читает, какого бота собирает.
  // Имя бота по умолчанию — коротко (владелец 19.09.2026), заголовок lead длиннее.
  shortTitle: (locale: WizardLocale) => (locale === 'ru' ? 'Кодовое слово' : 'Code word'),
  lead(locale: WizardLocale) {
    const ru = locale === 'ru';
    return {
      title: ru ? 'Кодовое слово в комментарии' : 'Code word in a comment',
      text: ru
        ? 'Пользователь пишет кодовое слово под вашей публикацией — бот отвечает ему в личных сообщениях, при желании проверяет подписку на аккаунт и отдаёт обещанное: ссылку, файл, промокод.'
        : 'A user writes the code word under your post — the bot replies in DMs, optionally checks the account subscription and hands over what you promised: a link, a file, a promo code.',
    };
  },
};

export const keywordBotIg: TemplateWizardDef = makeIgWizard(KEYWORD_BOT_IG_CFG);
